import React from 'react';

const DropdownMenu = ({ children, width, className, opened }) => (
  <ul className={`a-dropdown-menu a-font-size-2 list-reset my0 ${className} ${opened ? 'opened' : ''}`} style={{ width: `${width}` }}>
    {children.map( (item, index) =>
      <li key={index} className="border-bottom border-gray-2">
        {item}
      </li>
    )}
  </ul>
);

DropdownMenu.defaultProps = {
  children: [],
  opened: false,
  className: 'right-0',
  width: '300px'
};

export default DropdownMenu;
